import { useEffect, useState, useRef, useLayoutEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSpring, a, config } from "react-spring";
import { useIntl } from "react-intl";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import style from "./index.module.scss";
import * as mainAction from "../../../../reduxStore/actions/main";
import * as mainNavAction from "../../../../reduxStore/actions/mainNav";
import { MISC_INFO, MODULES } from "../../../../reduxStore/actions/main";
import { pageNames } from "../../../../reduxStore/reducers/main.js";

function TapperController(props) {
  const resizeTimer = useRef();
  const [navItems, setNavItems] = useState([]);
  const container = useRef(null);
  const [spanClass] = useState("");
  const [currentPage, setCurrentPage] = useState(pageNames.map);
  const intl = useIntl();

  const resizeTextContainer = () => {
    clearTimeout(resizeTimer.current);

    resizeTimer.current = setTimeout(() => {
      if (null == container.current) return;

      const children = container.current.childNodes;
      for (let key in children) {
        const child = children[key];
        if (children.hasOwnProperty(key)) {
          if (!child.classList.contains("not-active")) {
            const childrenWidth = // span
              child.lastChild.clientWidth +
              // svg
              child.firstChild.clientWidth;
            // die 2 ist ein puffer, weil manche kleinen worte auch abgehackt werden!
            child.style.width = childrenWidth + 2 + "px";

            child.lastChild.classList.add("text-overflow-ellipsis");
          } else {
            child.lastChild.classList.remove("text-overflow-ellipsis");
          }
        }
      }
    }, 100);
  };
  const [springProps] = useSpring(() => ({
    from: {
      opacity: 0,
      transform: "translateY(10rem)",
    },
    to: {
      opacity: 1,
      transform: "translateY(0)",
    },
    onRest: resizeTextContainer,
    config: { ...config.wobbly },
  }));

  const handleClick = (e, id, needStyling, onComplete) => {
    // close all items
    if (needStyling) {
      //set width & paddingRight
      const children = e.target.children;
      const svg = children[0];
      const span = children[1];
      e.target.style.width = svg.clientWidth + span.clientWidth + "px";
    }
    // run Callback
    if (onComplete) onComplete();
  };

  useEffect(() => {
    setCurrentPage(props.pathname.split("/")[1]);
  }, [props.pathname]);

  // Set entry to correct with, if click came from mainMenu
  useLayoutEffect(() => {
    if ("close" !== props.status) return;

    resizeTextContainer();
  }, [props.status, props.pathname]);

  useEffect(() => {
    setTimeout(() => {
      const globalParams = new URLSearchParams(props.location.search);

      let navItems = [];
      const reorder = () => {
        let tabbarOrder = MISC_INFO.tabBarOrder;
        if (!tabbarOrder || !tabbarOrder.length) return navItems;
        const orderedList = [];
        tabbarOrder.forEach((orderedItem) => {
          navItems.forEach((navItem) => {
            if (navItem.id === orderedItem) {
              orderedList.push(navItem);
            }
          });
        });

        return orderedList;
      };
      if (MODULES.hatNeuigkeiten) {
        navItems.push({
          id: "news",
          icon: "megaphone",
          text: intl.formatMessage({ id: "menu.news" }),
          action: () => {
            props.history.push(
              `/${pageNames.news}/?${globalParams.toString()}`
            );
          },
          newPage: true,
        });
      }
      if (MODULES.hatVeranstaltungen) {
        navItems.push({
          id: "events",
          icon: "calendar",
          text: intl.formatMessage({ id: "menu.event" }),
          action: () => {
            props.history.push(
              `/${pageNames.events}/?${globalParams.toString()}`
            );
          },
          newPage: true,
        });
      }
      const map = {
        id: "map",
        icon: "map",
        text: intl.formatMessage({ id: "menu.map" }),
        action: () => {
          props.history.push(
            `/${pageNames.map}/${pageNames.info}/?${globalParams.toString()}`
          );
        },
        newPage: true,
      };

      navItems.push(map);
      if (1 === navItems.length) return;

      navItems.push({
        id: "menu",
        icon: "bars",
        action: () => props.preOpenMenu(),
        newPage: false,
        ariaLabel: intl.formatMessage({ id: "menu.screenreader.menuButton" }),
      });
      navItems = reorder();

      setNavItems(navItems);
    }, 100);
  }, [intl.locale]);

  useLayoutEffect(() => {
    if (container.current == null) return;

    container.current.childNodes.forEach((button) => {
      const buttonChildren = button.childNodes;
      const svg = buttonChildren[0];
      button.style.width = svg.clientWidth + "px";
    });
  }, [navItems, currentPage]);

  // das "mb-auto"-div über dem Content sorgt dafür, dass das Menü immer
  // ganz runter gedrückt wird!
  if (navItems.length && !props.isTerminal) {
    return (
      <div
        className={`${style.Container} mt-auto d-flex align-items-center
      general-margin-horizontally general-margin-bottom pointer-event-on `}
      >
        <a.div
          ref={container}
          style={springProps}
          className={`${style.TapperController} mt-auto
                 d-flex p-3 tapperController`}
        >
          {navItems.map((navItem, index) => {
            const itemMarginRight =
              index !== navItems.length - 1 ? style.rightMargin : "";
            const isActive = navItem.id === currentPage;

            return (
              <button
                key={navItem.id}
                aria-label={navItem.ariaLabel}
                className={`${style.button} footerMenu__button ${
                  isActive
                    ? `${style.active} footerMenu__button--active`
                    : "not-active"
                } text-nowrap overflow-hidden border-0 d-flex align-items-center rounded-5 ${itemMarginRight} text-overflow-ellipsis`}
                onClick={(e) =>
                  handleClick(e, navItem.id, navItem.newPage, navItem.action)
                }
              >
                <FontAwesomeIcon icon={navItem.icon} />
                <span className={isActive ? spanClass : ""}>
                  {navItem.text}
                </span>
              </button>
            );
          })}
        </a.div>
      </div>
    );
  } else return null;
}

const mapStateToProps = (state) => {
  return {
    currentPage: state.main.currentPage,
    pageReload: state.main.pageReload,
    status: state.mainMenu.status,
    pathname: state.router.location.pathname,
    language: state.main.language,
    isTerminal: state.main.isTerminal,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLanguage: (key) => dispatch(mainAction.setLanguage(key)),
    setPage: (page) => dispatch(mainAction.setPage(page)),
    preOpenMenu: () => dispatch(mainNavAction.setPreOpen()),
  };
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TapperController)
);
